// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"7f5580dd0069eedce3ef","532":"8bbf4a81c065a9b9699d","574":"3b08df9fd2eea414a563","592":"85633cff0cb4ea807213","736":"c841b9737ef382dcbc71"}[chunkId] + ".js";
};